var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Money } from "./../../Primitives/Money";
import { DateConverter } from "./../../../../converters/DateConverter";
export class Payment {
  constructor(_data) {
    /**
     */
    __publicField(this, "ApprovedAt");
    /**
     */
    __publicField(this, "Collected");
    /**
     */
    __publicField(this, "CreatedAt");
    /**
     */
    __publicField(this, "Id");
    /**
     */
    __publicField(this, "IsRefund");
    /**
     */
    __publicField(this, "MerchantReference");
    /**
     */
    __publicField(this, "Quoted");
    /**
     */
    __publicField(this, "Status");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof Payment
     */
    __publicField(this, "$type", "V1.Orders.Get.Payment");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.ApprovedAt = DateConverter.from(_data["ApprovedAt"]);
      if (_data["Collected"]) {
        const collected_ = new Money();
        this.Collected = collected_.init(_data["Collected"]);
      }
      this.CreatedAt = DateConverter.from(_data["CreatedAt"]);
      this.Id = _data["Id"];
      this.IsRefund = _data["IsRefund"];
      this.MerchantReference = _data["MerchantReference"];
      if (_data["Quoted"]) {
        const quoted_ = new Money();
        this.Quoted = quoted_.init(_data["Quoted"]);
      }
      this.Status = PaymentStatus[_data["Status"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["$type"] = this.$type;
    _data["ApprovedAt"] = DateConverter.toIsoUtcString(this.ApprovedAt);
    _data["Collected"] = this.Collected ? this.Collected.toJSON() : void 0;
    _data["CreatedAt"] = DateConverter.toIsoUtcString(this.CreatedAt);
    _data["Id"] = this.Id;
    _data["IsRefund"] = this.IsRefund;
    _data["MerchantReference"] = this.MerchantReference;
    _data["Quoted"] = this.Quoted ? this.Quoted.toJSON() : void 0;
    _data["Status"] = PaymentStatus[this.Status];
    return _data;
  }
}
export var PaymentStatus = /* @__PURE__ */ ((PaymentStatus2) => {
  PaymentStatus2["Created"] = "Created";
  PaymentStatus2["Approved"] = "Approved";
  return PaymentStatus2;
})(PaymentStatus || {});
